import React, { useContext, useEffect, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import '../css/ZeroStateLicensedBanksCard.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import UtilityService from '../services/UtilityService';

const ZeroStateLicensedBanksCard = observer((props = {}) => {
  const { contextHelpManager } = useContext(MobXProviderContext);

  const { additionalClassNames } = props;

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { testBuilderContextHelpId } = contextHelpManager;
      if (!contextHelpManager.testBuilderContextHelpData) {
        await contextHelpManager.fetchContextHelp(testBuilderContextHelpId);
      }
      setIsLoading(false);
    })();
  }, []);

  const renderZeroStateLicensedBanksCard = () => {
    const parsedTestBuilderContextHelpData = UtilityService.reactHtmlParserWrapper(
      contextHelpManager.testBuilderContextHelpData || ''
    )?.parsed;

    return (
      <div className={classNames('ZeroStateLicensedBanksCard', additionalClassNames)} tabIndex={0}>
        {parsedTestBuilderContextHelpData}
      </div>
    );
  };

  return !isLoading && contextHelpManager.testBuilderContextHelpData ? renderZeroStateLicensedBanksCard() : null;
});
export default ZeroStateLicensedBanksCard;

SatCoreRegister('ZeroStateLicensedBanksCard', ZeroStateLicensedBanksCard);
